<template>
  <!-- align-middle -->
  <span
    v-if="isLoading || isReactive"
    class="animate-spin border-2 border-white border-l-transparent rounded-full w-5 h-5 ltr:mx-4 rtl:mx-4 inline-block"
  ></span>
</template>

<script setup>
const props = defineProps({
  isLoading: {
    type: Boolean,
    required: false
  },
  isReactive: {
    type: Boolean,
    required: false
  }
});
</script>
